import React from 'react';
import Info from '../../components/Info';
import SmallCardInfo from '../../components/SmallCardInfo';
import tv from 'images/icons/tv-outline.svg';
import option from 'images/icons/options-outline.svg';
import radio from 'images/icons/radio-outline.svg';
import lock from 'images/icons/lock-closed-outline.svg';
import VideoToolDescription from 'components/VideoToolDescription';

type ComparisonProps = {
  id: string,
}
const Comparison:React.FC<ComparisonProps> = ({id}) => {

  const featureCards = [
    {img: tv, title: 'Quick Start', firstDcp: 'Free set up and ongoing training', secondDcp: '', className: 'shadow'},
    {img: option, title: 'Simple Process', firstDcp: 'Simple two-step process – no app or software to download', secondDcp: '', className: 'shadow'},
    {img: radio, title: 'Quality Streaming', firstDcp: 'Real-time, High definition audio-visual streaming, recording and storage', secondDcp: '', className: 'shadow'},
    {img: lock, title: 'Secure Storage', firstDcp: 'Secure transfer, storage and download of data', secondDcp: '', className: 'shadow'},
  ]

  return (
    <div id={id}>
      <VideoToolDescription />
      {/* how we are different */}
      <div className="mt-5 sm:mx-5 md:mx-10 lg:mx-48">
        <div className="">
          <Info title={'How Are We Different?'} dcp={"We create a direct audio-visual connection to portable devices by sending an SMS or email link allowing users to see, hear and record every session, and idenify their location. We empower clients to virtually connect with customers across a broad range of industries in countries across the world. Clients using InFocus have improved operational costs while reducing service time frames and improving customer experience and satisfaction."} />
        </div>
      </div>

      {/* four difference */}
      <div className="mt-5  md:mx-2  lg:mx-40 lg:mx-56 lg:flex justify-center">
        {featureCards.map((item, index) => {
          return <SmallCardInfo style={{flex: 1}} className={`col-span-1 shadow-lg ${item.className ? item.className : ''}`} key={index} img={item.img} title={item.title} firstDcp={item.firstDcp} secondDcp={item.secondDcp}/>
        })}
      </div>
      
    </div>
  )
}

export default Comparison;